//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

import {
    mapState, mapMutations, mapGetters, mapActions
} from "vuex";
import QfCollapsibleItems from "./qf-collapsible-items.vue";
import QfScreens from "./qf-screens.vue";
import QfCollapsibleFragments from "./qf-collapsible-fragments.vue";

export default {
    name: "QfUiLeftContainer",
    components: { QfCollapsibleFragments, QfScreens, QfCollapsibleItems },
    data() {
        return {
            sideCategories: [
                { label: this.$t("userInterface.pagesTitle"), value: "pages" },
                { label: this.$t("userInterface.layoutTitle"), value: "layout" }
            ],
            activeControl: null,
            scrollPaddingFix: { padding: "1px" },
            thumb: {
                right: "-10px", borderRadius: "4px", width: "5px", opacity: 0.3
            },
            // sideCategory: "pages",
            sideCategory: "layout",
            collapsible: {
                basic: true, layout: true, standard: true, form: true, custom: false, icons: false, fragments: false
            },
            showEmptyOnes: false
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp"]),
        ...mapState("components", ["appInterfaces", "readOnly", "currentInterfaceProperties", "qfDebug", "sidebarComponents", "sidebarLoading", "routeEnter", "fragments"]),
        onPage() {
            return this.sideCategory === "pages";
        },
        onLayout() {
            return this.sideCategory === "layout";
        },
        layoutStructure() {
            return this.sidebarComponents.basic.layout.map(this.componentInitialisation);
        },
        standardElements() {
            let elements = this.sidebarComponents.basic.standard.map(this.componentInitialisation);
            if (!this.currentApp.blockchainType || this.currentApp.blockchainType === "STANDARD") {
                elements = elements.filter(el => el.type !== "ctrl-metamask");
            }
            return elements;
        },
        formElements() {
            return this.sidebarComponents.basic.form.map(this.componentInitialisation);
        },
        fragmentsStructure() {
            const fragments = [];

            this.appInterfaces.forEach(entry => {
                const { type, id, name, description } = entry;

                if (type === "FRAGMENT") {
                    fragments.push({
                        id,
                        description,
                        icon: "mdi-puzzle",
                        type: "ctrl-fragment",
                        label: name.charAt(0).toUpperCase() + name.slice(1)
                    });
                }
            });

            return fragments;
        },
        basicLoading() {
            return this.sidebarLoading.basic;
        },
        readonlyPermission() {
            return this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly;
        }
    },
    watch: {
        routeEnter: {
            handler(state) {
                if (state) {
                    this.resetCollapsibleState();
                    this.setRouteEnter(false);
                }
            },
            immediate: true
        }
    },
    created() {
        if (this.qfDebug) {
            this.sideCategory = "layout";
        }
    },
    methods: {
        ...mapMutations("components", ["setRouteEnter"]),
        ...mapActions("components", ["getInterfaceModel"]),
        componentInitialisation(component) {
            return {
                icon: component.icon || "mdi-puzzle",
                type: component.componentName,
                label: component.label || component.name.charAt(0).toUpperCase() + component.name.slice(1)
            };
        },
        setActive(payload) {
            const { type, shift, id = null } = payload;
            const { code, _details } = this.currentInterfaceProperties;
            if (this.readOnly || this.readonlyPermission) {
                if (code || _details.code) {
                    this.$toast.showNotify({
                        type: "warning",
                        message: this.$t("userInterface.addComponentReadonlyMode")
                    });
                } else {
                    this.$toast.showNotify({
                        type: "warning",
                        message: this.$t("userInterface.addInterfaceFirst")
                    });
                }
            } else if (type === "ctrl-fragment") {
                this.activeControl = id;
                this.getInterfaceModel({ guid: id }).then(() => {
                    this.$emit("action", { type: "add-component", data: { type, shift, id } });
                });
            } else {
                this.activeControl = type;
                this.$emit("action", { type: "add-component", data: { type, shift, id } });
            }
        },
        updateActiveInterface(guid) {
            this.$refs.screens.setSelectedInterface(guid);
        },
        clearActiveInterface() {
            this.$refs.screens.clearInterface();
        },
        validateLeave() {
            return this.$refs.screens.validateChangeAction();
        },
        checkForModifications() {
            return this.$refs.screens.checkForModifications();
        },
        resetCollapsibleState() {
            this.sideCategory = "pages";
            this.collapsible = {
                basic: false, layout: false, standard: false, form: false, custom: false, icons: false
            };
        }
    }
};
